module.exports = __webpack_public_path__ + "img/injection.e3c97fa7.svg";